import { element } from 'prop-types';
import SpecialDiscount from './SpecialDiscount';
import SpecialDiscountApproval from './SpecialDiscountApproval';
import SpecialDiscountDetail from './SpecialDiscountDetail';
import SpecialDiscountDetailSdp from './SpecialDiscountDetailsSdp';

const SpecialDiscountConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/special-discount',
      element: <SpecialDiscount />,
    },
    {
      path: '/special-discount-approval',
      element: <SpecialDiscountApproval />,
    },
    {
      path: "/special-discount-details-sdr/:id",
    element: <SpecialDiscountDetail />,
    },{
      path: "/special-discount-details-sdp/:id",
    element: <SpecialDiscountDetailSdp/>,
    }
  ],
};

export default SpecialDiscountConfig;
